// Copied from the ClassTutor portal (src/app/scss/style.ts) so ported components keep their colours.
const BREAK_POINTS = {
  MAX_XL: '1600px',
  MIN_XL: '1400px',
  MAX_L: '1200px',
  MIN_L: '1025px ',
  MAX_S: '1024px',
  MIN_S: '769px',
  MAX_XS_: '768px',
  MIN_XS: '481px',
  MAX_XXS_: '480px',
  MIN_XXS: '320px '
};

const MAIN_COLORS = {
  primary: '#4C54A0',
  secondary: '#92929D',
  secondary2: '#C4C4C4',
  success: '#45B1B2',
  danger: '#FC5A5A',
  info: '#50B5FF',
  warning: '#FFC542',
  white: '#ffffff'
};

const FONT_SIZES = { SM: '12px', MD: '16px', LG: '24px' };
const FONT_WEIGHTS = { B7: '700', B6: '600', B4: '400' };
const THEME_COLORS = { primaryText: '#000', secondaryText: '#92929D' };

/** Portal UI tokens that live in its SCSS and component styles. */
const UI = {
  pageBg: '#F8F9FC',
  text: '#171725',
  bodyText: '#3A3A49',
  textSoft: '#44444F',
  textMuted: '#696974',
  border: '#E2E2EA',
  borderInput: '#D2D2D5',
  todayTeal: '#45B1B3',
  zoomBlue: '#2196F3',
  primaryHover: '#2C368E',
  link: '#5C63AC',
  secondaryBg: '#F1F1F5',
  hoverBg: '#EDEEF5',
  completeGreen: '#3DD598',
  cardRadius: '20px',
  cardRadiusMobile: '12px',
  buttonRadius: '7px',
  inputRadius: '10px'
};

const STYLE_DEFAULTS = { MAIN_COLORS, THEME_COLORS, BREAK_POINTS, FONT_SIZES, FONT_WEIGHTS, UI };

export default STYLE_DEFAULTS;
